// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router.js'

//使用Element-ui   引入整个Element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)


//使用axios
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'

Vue.use(VueAxios, axios)

// 根据运行环境决定BaseURL地址
if (window.location.host === "127.0.0.1:8000") {
  //本地
  axios.defaults.baseURL = 'http://127.0.0.1:8000/api/'
} else {
  // 万物追溯 baseURL
  axios.defaults.baseURL = 'https://api.wwzhuisu.cn/api/'
}


//设置跨域请求(允许携带cookie)
axios.defaults.withCredentials = true
//进行POST请求的时候将数据格式改变
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.transformRequest = [function (data) {
//    对data进行数据转化
  return Qs.stringify(data)
}]


//使用vue-router
import Router from 'vue-router'
import el from "element-ui/src/locale/lang/el";

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}


new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})

//是否阻止启动生产消息，常用作指令
Vue.config.productionTip = false




// WEBPACK FOOTER //
// ./src/main.js